import styled from 'styled-components';

import {
  Button,
} from 'web-components';
import {
  Flex,
} from 'web-styled';

export const Header = styled(Flex).attrs<{ isError?: boolean }>({
  align: 'center',
  justify: 'space-between',
  spacing: 8,
})`
  width: 100%;
  padding: 15px 25px;
  border-bottom: 1px solid #e5e5e5;
  background: ${props => (props.isError ? props.theme.colors.darkDanger : props.theme.colors.modalHeader)};
`;

export const Close = styled(Button).attrs({
  appearance: 'link',
})`
  color: #fff;
  font-size: 13px;
  font-weight: normal;
  text-shadow: none;
  opacity: 0.5;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;

  &:hover {
    color: #fff;
    text-decoration: none;
    opacity: 0.9;
  }
`;

export const Title = styled(Flex).attrs({
  align: 'center',
  fillSpace: true,
})`
  color: #fff;
  font-size: 18px;
  margin: 0;

  img {
    height: 16px;
    display: block;
    margin-right: 5px;
  }
`;

export const Body = styled(Flex)`
  padding: 25px;
  width: 100%;
`;
